var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 63.8",
    style: {
      enableBackground: "new 0 0 64 63.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EC6335;}\r\n\t.st1{fill:#FFAC58;}\r\n\t.st2{fill:#F47B33;}\r\n\t.st3{fill:#F7B8A1;}\r\n\t.st4{fill:#060606;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    transform: "translate(0.873 1.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    transform: "translate(3.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    className: "st0",
    d: "M20.2,52.9l34,2.3c0.6,0,1.2-0.4,1.2-1.1c0,0,0,0,0,0l3.3-48.9c0-0.6-0.4-1.2-1.1-1.2 c0,0,0,0,0,0l-34-2.3c-0.6,0-1.2,0.4-1.2,1.1c0,0,0,0,0,0l-3.3,48.9C19.1,52.3,19.6,52.8,20.2,52.9 C20.2,52.9,20.2,52.9,20.2,52.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    transform: "translate(0 5.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    className: "st1",
    d: "M20.3,52.9h26l9.2-9.2v-41c0-0.6-0.5-1.2-1.2-1.2H20.3c-0.6,0-1.1,0.5-1.2,1.1v49 C19.2,52.4,19.7,52.9,20.3,52.9C20.3,52.9,20.3,52.9,20.3,52.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52",
    className: "st2",
    d: "M54.4,1.6h-4.6c0.6,0,1.2,0.5,1.2,1.2v41l0,4.6l4.6-4.6v-41C55.6,2.1,55.1,1.6,54.4,1.6 z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53",
    className: "st3",
    d: "M46.4,52.9v-8.1c0-0.6,0.5-1.2,1.2-1.2h8.1L46.4,52.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    transform: "translate(0 0.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    className: "st4",
    d: "M62.2,4l-34-2.3C27,1.6,26.1,2.5,26,3.6l-0.3,4h-4.5c-1.1,0-2,0.9-2,2v49c0,1.1,0.9,2,2,2h26 c0.2,0,0.4-0.1,0.6-0.3l3.9-3.9c0,0,0.1,0,0.1,0l6.7,0.4c1.1,0,2-0.8,2.1-1.9L64,6.1C64.1,5,63.3,4.1,62.2,4L62.2,4z M48.1,57.6 v-6c0-0.2,0.1-0.3,0.3-0.3l0,0h6L48.1,57.6z M59,54.9c0,0.2-0.1,0.3-0.3,0.3l-5.3-0.4l3.7-3.6c0.2-0.2,0.3-0.4,0.3-0.6v-41 c0-1.1-0.9-2-2-2h-9c-0.5,0-0.9,0.4-0.8,0.9c0,0.5,0.4,0.8,0.8,0.8h9c0.2,0,0.3,0.1,0.3,0.3v0v40h-7.2c-1.1,0-2,0.9-2,2v7.2H21.2 c-0.2,0-0.3-0.1-0.3-0.3l0,0v-49c0-0.2,0.1-0.3,0.3-0.3h20.5c0.5,0,0.9-0.4,0.8-0.9c0-0.5-0.4-0.8-0.8-0.8H27.5l0.3-3.9 c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0l34,2.3c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0L59,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    className: "st4",
    d: "M50,29H26.5c-0.5,0-0.9,0.4-0.9,0.8c0,0.5,0.4,0.9,0.8,0.9c0,0,0,0,0.1,0H50 c0.5,0,0.9-0.4,0.8-0.9C50.8,29.3,50.5,29,50,29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    className: "st4",
    d: "M50,35H26.5c-0.5,0-0.9,0.4-0.8,0.9c0,0.5,0.4,0.8,0.8,0.8H50c0.5,0,0.9-0.4,0.8-0.9 C50.8,35.4,50.5,35,50,35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    className: "st4",
    d: "M25.6,23.8c0,0.5,0.4,0.9,0.9,0.9c0,0,0,0,0,0H50c0.5,0,0.9-0.4,0.8-0.9 c0-0.5-0.4-0.8-0.8-0.8H26.5C26,22.9,25.6,23.3,25.6,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64",
    className: "st4",
    d: "M29.8,17.8c0,0.5,0.4,0.9,0.9,0.9l0,0h15.3c0.5,0,0.9-0.4,0.9-0.8c0-0.5-0.4-0.9-0.8-0.9 c0,0,0,0-0.1,0H30.6C30.1,16.9,29.8,17.3,29.8,17.8L29.8,17.8L29.8,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65",
    className: "st4",
    d: "M41.6,52.2l-4.7,0h-1.6c-0.9,0-1.6-0.2-1.8-1.2c-0.2-0.9-1.4-0.8-1.7,0 c-0.6,1.9-1.6,1.1-2.1-0.1c-0.5-1.3-0.8-2.6-0.9-4c-0.2-1-1.7-0.7-1.7,0.2c0,1.2-0.2,2.5-0.5,3.7c-0.4,1.2-0.8,2.4-1.3,3.6 c-0.4,1,1.3,1.5,1.7,0.5c0.4-1,0.8-2.1,1.2-3.2c0.6,1.4,1.8,3,3.6,2.1c0.3-0.2,0.6-0.4,0.9-0.7c0.9,1,2.3,1,3.5,1 c1.8,0,3.6,0,5.4,0c0.5,0,0.9-0.4,0.9-0.9C42.5,52.6,42.1,52.2,41.6,52.2C41.6,52.2,41.6,52.2,41.6,52.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,13.5H1.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h8.9c0.6,0,1,0.4,1,1S10.8,13.5,10.2,13.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,7.5c-0.1,0-0.2,0-0.3-0.1L4,4.5C3.5,4.3,3.2,3.8,3.4,3.2c0.2-0.5,0.7-0.8,1.3-0.6l8.9,3c0.5,0.2,0.8,0.7,0.6,1.3 C14,7.3,13.6,7.5,13.2,7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,22.4c-0.5,0-0.9-0.3-1-0.8c-0.1-0.5,0.2-1.1,0.8-1.2l8.9-2c0.5-0.1,1.1,0.2,1.2,0.8c0.1,0.5-0.2,1.1-0.8,1.2l-8.9,2 C4.4,22.4,4.4,22.4,4.3,22.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocs);
export default __webpack_public_path__ + "static/media/file-docs.e16c5e4b.svg";
export { ForwardRef as ReactComponent };